export enum SubstitutionsTypes {
  /* И. О */
  acting = 'acting',
  /* Замещающий*/
  deputy = 'deputy',
}

export enum DivisionsTypes {
  /* Подразделения без руководителя*/
  withoutSupervisors = 'without_supervisors',
  /* подразделения с И.О. */
  withActing = 'with_acting',
}

export enum SortDivision {
  divisionAsc = 'division_asc',
  divisionDesc = 'division_desc',
  supervisorAsc = 'supervisor_asc',
  supervisorDesc = 'supervisor_desc',
}
